import * as Yup from "yup";

export const perfilUsuarioSchema = Yup.object().shape({});

export const perfilUsuarioSchemaForm = Yup.object().shape({});
